export class BlockChatClass {
    constructor() {
        this.id = 0;
        this.uuid = "";
    }
}